import { defineStore } from 'pinia';
import { getReadingResult, deleteReadingResult, insertReadingResult } from '../api';
import _ from 'lodash';

export interface ReadingResultList {
  check_pred: boolean,
  origin_filename: string,
  patient_id: string,
  patient_name: string,
  reading_time: number,
  score: number,
  study_date: string,
  unique_filename: string,
  user_id: string,
  selected: boolean,
  showFileNameTooltip: boolean,
  showIdTooltip: boolean;
  showNameTooltip: boolean;
  showDateTooltip: boolean;
}

// Pinia 스토어 정의
export const useReadingResultStore = defineStore('reading', {
  state: () => ({
    readingResultList: [] as ReadingResultList[],
    showNewIcon: false,
    selectedListCount: 0
  }),
  actions: {
    initReadingResultList() {
      this.readingResultList = [];
    },
    async setReadingResultList() {
      const res = await getReadingResult();
      this.readingResultList = [];
      // if(res.length > 0) {
      if(res) {
        for(let i=0; i<res.length; i++) {
          this.readingResultList.push(
            {
              check_pred: res[i].check_pred,
              origin_filename: res[i].origin_filename,
              patient_id: res[i].patient_id,
              patient_name: res[i].patient_name,
              reading_time: res[i].reading_time,
              score: res[i].score,
              study_date: res[i].study_date,
              unique_filename: res[i].unique_filename,
              user_id: res[i].user_id,
              selected: false,
              showFileNameTooltip: false,
              showIdTooltip: false,
              showNameTooltip: false,
              showDateTooltip: false,
            }
          );
        }
      }
    },
    getSelectedListCount() {
      this.selectedListCount = this.readingResultList.reduce(
        (count, item) => count + (item.selected ? 1 : 0), 0
      );
    },
    async insertReadingResult() {
      await insertReadingResult();
    },
    async deleteReadingResultList() {
      const res = await deleteReadingResult();
      if(res) {
        await this.setReadingResultList();
        this.getSelectedListCount();
      }
    },
    setShowNewIcon(show: boolean) {
      this.showNewIcon = show;
    }
  },
  getters: {
    getReadingResultList(state) {
      return state.readingResultList;
    },
    getSelectedCount(state) {
      return state.selectedListCount;
    },
    getShowNewIcon(state): boolean {
      return state.showNewIcon;
    }
  },
});
